import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import api from '../utils/api';
import ProductCard from '../components/ProductCard';

const PRICE_RANGES = [
  {l:'Under ₹2,000',mn:'',mx:2000},
  {l:'₹2,000–₹5,000',mn:2000,mx:5000},
  {l:'₹5,000–₹10,000',mn:5000,mx:10000},
  {l:'Above ₹10,000',mn:10000,mx:''},
];

export default function ShopPage() {
  const { category }   = useParams();
  const [searchParams] = useSearchParams();
  const [products, setProducts]     = useState([]);
  const [categories, setCategories] = useState([]);
  const [total, setTotal]           = useState(0);
  const [loading, setLoading]       = useState(true);
  const [page, setPage]             = useState(0);
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [priceRange, setPriceRange] = useState({mn:'',mx:''});
  const [filters, setFilters]       = useState({
    sort:     searchParams.get('sort')     || '',
    search:   searchParams.get('search')   || '',
    featured: searchParams.get('featured') || '',
    is_new:   searchParams.get('is_new')   || '',
  });
  const LIMIT = 12;

  useEffect(() => {
    api.get('/categories').then(r => setCategories(r.data || [])).catch(()=>{});
  }, []);

  const fetchProducts = useCallback(async (pg=0) => {
    setLoading(true);
    try { window.scrollTo({top:0,behavior:'smooth'}); } catch {}
    const p = new URLSearchParams();
    if (category)         p.set('category', category);
    if (filters.sort)     p.set('sort',     filters.sort);
    if (priceRange.mn)    p.set('min_price',priceRange.mn);
    if (priceRange.mx)    p.set('max_price',priceRange.mx);
    if (filters.search)   p.set('search',   filters.search);
    if (filters.featured) p.set('featured', '1');
    if (filters.is_new)   p.set('is_new',   '1');
    p.set('limit', LIMIT); p.set('page', pg);
    try {
      const res = await api.get(`/products?${p}`);
      setProducts(res.data.products || []);
      setTotal(res.data.total || 0);
      setPage(pg);
    } catch {}
    finally { setLoading(false); }
  }, [category, filters, priceRange]);

  useEffect(() => { fetchProducts(0); }, [category, filters, priceRange]);

  const currentCat = categories.find(c => c.slug === category);
  const totalPages = Math.ceil(total / LIMIT);
  const clearAll = () => { setFilters({sort:'',search:'',featured:'',is_new:''}); setPriceRange({mn:'',mx:''}); };

  const pageTitle = filters.search ? `Search: "${filters.search}"` : filters.is_new ? 'New Arrivals' : filters.featured ? 'Featured Sarees' : currentCat ? currentCat.name : 'All Collections';

  const Filters = ({close}) => (
    <div>
      <div style={{marginBottom:24,paddingBottom:24,borderBottom:'1px solid #f8ecff'}}>
        <h3 style={{fontFamily:"'Jost',sans-serif",fontSize:9,letterSpacing:3,textTransform:'uppercase',color:'#64748b',marginBottom:12}}>Collections</h3>
        <Link to="/collections" style={{display:'block',fontFamily:"'Cormorant Garamond',serif",fontSize:16,padding:'7px 0',borderBottom:'1px solid #eff6ff',textDecoration:'none',color:!category?'#7c3aed':'#31263f',fontWeight:!category?700:400}} onClick={close}>All Sarees</Link>
        {categories.map(cat => (
          <Link key={cat.id} to={`/collections/${cat.slug}`} style={{display:'block',fontFamily:"'Cormorant Garamond',serif",fontSize:16,padding:'7px 0',borderBottom:'1px solid #eff6ff',textDecoration:'none',color:category===cat.slug?'#7c3aed':'#31263f',fontWeight:category===cat.slug?700:400}} onClick={close}>
            {cat.icon} {cat.name} <span style={{float:'right',fontSize:11,color:'#aaa'}}>{cat.product_count}</span>
          </Link>
        ))}
      </div>
      <div style={{marginBottom:24,paddingBottom:24,borderBottom:'1px solid #f8ecff'}}>
        <h3 style={{fontFamily:"'Jost',sans-serif",fontSize:9,letterSpacing:3,textTransform:'uppercase',color:'#64748b',marginBottom:12}}>Price Range</h3>
        <div style={{display:'flex',gap:7,marginBottom:12}}>
          <input className="form-input" type="number" placeholder="Min ₹" value={priceRange.mn} onChange={e=>setPriceRange(p=>({...p,mn:e.target.value}))} style={{flex:1,padding:'8px 10px',fontSize:12}}/>
          <input className="form-input" type="number" placeholder="Max ₹" value={priceRange.mx} onChange={e=>setPriceRange(p=>({...p,mx:e.target.value}))} style={{flex:1,padding:'8px 10px',fontSize:12}}/>
        </div>
        {PRICE_RANGES.map(r => {
          const active = String(priceRange.mn)===String(r.mn) && String(priceRange.mx)===String(r.mx);
          return <button key={r.l} onClick={()=>setPriceRange({mn:r.mn,mx:r.mx})} style={{display:'block',width:'100%',textAlign:'left',padding:'9px 12px',border:`1px solid ${active?'#7c3aed':'#eadcf8'}`,marginBottom:7,fontFamily:"'Jost',sans-serif",fontSize:12,cursor:'pointer',background:active?'#fff1e8':'transparent',color:active?'#7c3aed':'#4a3463'}}>{r.l}</button>;
        })}
      </div>
      <div style={{marginBottom:24,paddingBottom:24,borderBottom:'1px solid #f8ecff'}}>
        <h3 style={{fontFamily:"'Jost',sans-serif",fontSize:9,letterSpacing:3,textTransform:'uppercase',color:'#64748b',marginBottom:12}}>Quick Filters</h3>
        {[{l:'✨ Featured',k:'featured'},{l:'🆕 New Arrivals',k:'is_new'}].map(f => (
          <button key={f.k} onClick={()=>setFilters(ff=>({...ff,[f.k]:ff[f.k]?'':'1'}))} style={{display:'inline-block',padding:'6px 14px',margin:'0 8px 8px 0',border:`1px solid ${filters[f.k]?'#7c3aed':'#eadcf8'}`,fontFamily:"'Jost',sans-serif",fontSize:12,cursor:'pointer',background:filters[f.k]?'#7c3aed':'transparent',color:filters[f.k]?'#fff':'#4a3463'}}>{f.l}</button>
        ))}
      </div>
      <button onClick={()=>{clearAll();close&&close();}} style={{fontFamily:"'Jost',sans-serif",fontSize:12,letterSpacing:1,color:'#c00',background:'none',border:'none',cursor:'pointer',padding:0,textDecoration:'underline'}}>✕ Clear All Filters</button>
    </div>
  );

  return (
    <div className="page">
      {/* Collection header */}
      <div style={{position:'relative',overflow:'hidden',minHeight:180,display:'flex',alignItems:'center',justifyContent:'center',background:currentCat?'#fde8e8':'#fff7fb'}}>
        <div style={{position:'absolute',inset:0,backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Cg fill='none' stroke='%237a1f1f' stroke-width='0.4' opacity='0.12'%3E%3Cpolygon points='30,5 55,30 30,55 5,30'/%3E%3Cpolygon points='30,15 45,30 30,45 15,30'/%3E%3C/g%3E%3C/svg%3E")`,backgroundSize:'60px 60px'}}/>
        <div style={{position:'relative',zIndex:2,textAlign:'center',padding:'40px 24px'}}>
          {currentCat && <div style={{fontSize:10,letterSpacing:3,color:'#f97316',marginBottom:8,textTransform:'uppercase',fontFamily:"'Jost',sans-serif"}}>✦ {currentCat.icon} Collections ✦</div>}
          <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.8rem,4vw,3.5rem)',color:'#7c3aed',fontStyle:'italic',lineHeight:1.1}}>
            {filters.search ? <><em>"{filters.search}"</em></> : <><em>{pageTitle}</em></>}
          </h1>
          {total > 0 && <div style={{fontSize:12,color:'#64748b',marginTop:8,fontFamily:"'Jost',sans-serif"}}>{total} sarees</div>}
        </div>
        <div style={{position:'absolute',top:0,left:0,right:0,height:3,background:'linear-gradient(90deg,transparent,rgba(122,31,31,0.4),rgba(122,31,31,0.7),rgba(122,31,31,0.4),transparent)'}}/>
        <div style={{position:'absolute',bottom:0,left:0,right:0,height:3,background:'linear-gradient(90deg,transparent,rgba(122,31,31,0.4),rgba(122,31,31,0.7),rgba(122,31,31,0.4),transparent)'}}/>
      </div>

      {/* Breadcrumb */}
      <div style={{background:'#fff',borderBottom:'1px solid var(--border)',padding:'10px 0'}}>
        <div className="container" style={{display:'flex',gap:8,fontSize:12,color:'#64748b',alignItems:'center',flexWrap:'wrap'}}>
          <Link to="/" style={{color:'#64748b'}}>Home</Link><span>›</span>
          <Link to="/collections" style={{color:'#64748b'}}>Collections</Link>
          {currentCat && <><span>›</span><span style={{color:'#7c3aed'}}>{currentCat.name}</span></>}
          {filters.search && <><span>›</span><span style={{color:'#7c3aed'}}>"{filters.search}"</span></>}
        </div>
      </div>

      {/* Mobile filter bar */}
      <div className="shop-mobile-bar" style={{display:'none',position:'sticky',top:'var(--nav-h)',zIndex:99,background:'#fff',borderBottom:'1px solid var(--border)',padding:'9px 14px',gap:10,alignItems:'center'}}>
        <button onClick={()=>setFilterDrawer(true)} style={{display:'flex',alignItems:'center',gap:6,padding:'9px 14px',border:'1.5px solid var(--border)',background:'none',fontFamily:"'Jost',sans-serif",fontSize:11,letterSpacing:1,textTransform:'uppercase',cursor:'pointer',whiteSpace:'nowrap'}}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="10" y1="18" x2="14" y2="18"/></svg>
          Filters
        </button>
        <select value={filters.sort} onChange={e=>setFilters(f=>({...f,sort:e.target.value}))} style={{flex:1,padding:'9px 32px 9px 10px',border:'1.5px solid var(--border)',fontSize:12,appearance:'none',background:`#fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23888' fill='none' stroke-width='1.5'/%3E%3C/svg%3E") no-repeat right 10px center`,fontFamily:"'Jost',sans-serif",outline:'none'}}>
          <option value="">Featured</option>
          <option value="newest">Newest</option>
          <option value="price_asc">Price: Low→High</option>
          <option value="price_desc">Price: High→Low</option>
        </select>
        <span style={{fontSize:11,color:'#64748b',whiteSpace:'nowrap',flexShrink:0}}>{total} items</span>
      </div>

      <div className="container" style={{paddingTop:24,paddingBottom:72}}>
        <div style={{display:'flex',gap:40,alignItems:'flex-start'}}>
          {/* Sidebar */}
          <aside className="shop-sidebar hidden-mobile" style={{width:240,flexShrink:0,position:'sticky',top:'calc(var(--nav-h)+16px)',maxHeight:'calc(100vh - var(--nav-h) - 32px)',overflowY:'auto'}}>
            <Filters close={()=>{}}/>
          </aside>

          {/* Products */}
          <div style={{flex:1,minWidth:0}}>
            <div className="shop-desktop-topbar hidden-mobile" style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24,paddingBottom:16,borderBottom:'1px solid var(--border)'}}>
              <span style={{fontFamily:"'Jost',sans-serif",fontSize:12,color:'#64748b'}}>{total} products</span>
              <select value={filters.sort} onChange={e=>setFilters(f=>({...f,sort:e.target.value}))} style={{padding:'9px 36px 9px 13px',border:'1.5px solid var(--border)',fontSize:12,appearance:'none',background:`#fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23888' fill='none' stroke-width='1.5'/%3E%3C/svg%3E") no-repeat right 13px center`,fontFamily:"'Jost',sans-serif",outline:'none',cursor:'pointer'}}>
                <option value="">Sort: Featured</option>
                <option value="newest">Newest First</option>
                <option value="price_asc">Price: Low→High</option>
                <option value="price_desc">Price: High→Low</option>
              </select>
            </div>

            {loading ? <div className="spinner"/> :
             products.length === 0 ? (
              <div style={{textAlign:'center',padding:'64px 0'}}>
                <div style={{fontSize:56}}>🧵</div>
                <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:'#7c3aed',fontStyle:'italic',margin:'12px 0 8px'}}>No products found</h3>
                <p style={{color:'#64748b',fontSize:14}}>Try adjusting your filters</p>
                <button onClick={clearAll} className="btn btn-outline" style={{marginTop:20}}>Clear Filters</button>
              </div>
            ) : (
              <>
                <div className="grid-3">{products.map(p => <ProductCard key={p.id} product={p}/>)}</div>
                {totalPages > 1 && (
                  <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:20,marginTop:48}}>
                    <button className="btn btn-outline" onClick={()=>fetchProducts(page-1)} disabled={page===0} style={{padding:'9px 20px',fontSize:11,opacity:page===0?0.4:1}}>← Prev</button>
                    <span style={{fontSize:13,color:'#64748b'}}>Page {page+1} of {totalPages}</span>
                    <button className="btn btn-outline" onClick={()=>fetchProducts(page+1)} disabled={page+1>=totalPages} style={{padding:'9px 20px',fontSize:11,opacity:page+1>=totalPages?0.4:1}}>Next →</button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Mobile filter drawer */}
      {filterDrawer && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:2000,display:'flex',justifyContent:'flex-end'}} onClick={()=>setFilterDrawer(false)}>
          <div style={{width:300,maxWidth:'90vw',background:'#fff7fb',height:'100%',display:'flex',flexDirection:'column'}} onClick={e=>e.stopPropagation()}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'16px 20px',borderBottom:'1px solid var(--border)',background:'#fff'}}>
              <span style={{fontFamily:"'Jost',sans-serif",fontSize:11,fontWeight:600,letterSpacing:3,textTransform:'uppercase'}}>Filters</span>
              <button onClick={()=>setFilterDrawer(false)} style={{background:'none',border:'none',fontSize:22,cursor:'pointer'}}>✕</button>
            </div>
            <div style={{flex:1,overflowY:'auto',padding:'0 20px 20px'}}><Filters close={()=>setFilterDrawer(false)}/></div>
            <div style={{padding:16,borderTop:'1px solid var(--border)',background:'#fff'}}>
              <button onClick={()=>setFilterDrawer(false)} className="btn btn-primary" style={{width:'100%',justifyContent:'center',padding:14}}>Show {total} Results</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
